const canvas = new fabric.Canvas("c");
const targetColor = { r: 139, g: 69, b: 19 }; // marrone

const images = document.querySelectorAll("img.ricolora-marrone");

let offsetX = 0;

images.forEach((imgElem, index) => {
  const imgSrc = imgElem.src;

  fabric.Image.fromURL(imgSrc, function (img) {
    img.scaleToWidth(300); // opzionale
    img.left = offsetX;
    offsetX += img.getScaledWidth() + 10;

    canvas.add(img);
    canvas.renderAll();

    setTimeout(() => {
      const ctx = canvas.getContext("2d");
      const imageData = ctx.getImageData(
        img.left,
        img.top,
        img.getScaledWidth(),
        img.getScaledHeight()
      );
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        const isNotWhite = !(r > 240 && g > 240 && b > 240);

        if (isNotWhite) {
          data[i] = targetColor.r;
          data[i + 1] = targetColor.g;
          data[i + 2] = targetColor.b;
        }
      }

      ctx.putImageData(imageData, img.left, img.top);
    }, 100);
  });
});

function matchHeights(className) {
  const elements = Array.from(document.querySelectorAll(`.${className}`));
  if (elements.length === 0) return;

  elements.forEach((el) => (el.style.height = "auto"));

  const maxHeight = Math.max(...elements.map((el) => el.offsetHeight));

  elements.forEach((el) => (el.style.height = `${maxHeight}px`));
}

function setupMatchHeight(className) {
  let resizeTimeout;

  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      matchHeights(className);
    }, 100); // Debounce per evitare troppi ricalcoli
  };

  matchHeights(className);

  window.addEventListener("resize", handleResize);
}

// Inizializzazione
document.addEventListener("DOMContentLoaded", () => {
  setupMatchHeight("product-card__title");

  // Ricalcolo forzato dopo 300ms (per sicurezza)
  setTimeout(() => {
    matchHeights("product-card__title");
  }, 1000);
});

setInterval(() => {
  matchHeights("product-card__title");
}, 10000);